import type { SubStatus } from '../subscriptions/api.ts';

const STATE: Record<SubStatus, { label: string; pill: string }> = {
  ACTIVE: { label: 'Active', pill: 'pill-success' },
  GRACE: { label: 'Grace period', pill: 'pill-pending' },
  BLOCKED: { label: 'Blocked', pill: 'pill-danger' },
  NOT_SET: { label: 'Not set', pill: 'pill-neutral' },
};

function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

function daysLeftText(iso: string): string | null {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const ms = d.getTime() - Date.now();
  const days = Math.ceil(ms / 86_400_000);
  if (days > 1) return `${days} days left`;
  if (days === 1) return '1 day left';
  if (days === 0) return 'Due today';
  const overdue = Math.abs(days);
  return overdue === 1 ? '1 day overdue' : `${overdue} days overdue`;
}

export function PlanCard({
  status,
  renewBy,
}: {
  status: SubStatus;
  renewBy: string | null;
}): JSX.Element {
  const state = STATE[status];
  const left = renewBy ? daysLeftText(renewBy) : null;

  return (
    <div className="card-paper p-5 space-y-3">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-medium text-muted-foreground">Plan</p>
        <span className={`pill ${state.pill}`}>{state.label}</span>
      </div>

      {renewBy ? (
        <div className="space-y-0.5">
          <p className="text-sm text-foreground/80">
            Renews by <span className="text-ink font-medium">{formatDate(renewBy)}</span>
          </p>
          {left && <p className="mono-meta text-muted-foreground">{left}</p>}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No renewal date on file.</p>
      )}
    </div>
  );
}
